/**
 * App Config — initialisation order, breakpoints, and animation tokens.
 *
 * [AppConfig]
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Sonnet 4.6
 */

import { log } from './log.js';

var consoleBanner = (function () {
  var info = (typeof ep_appinfo !== 'undefined') ? ep_appinfo : {};
  var v = info.version || '';
  var c = info.commit || '';
  var y = new Date().getFullYear();
  return ''
    + '\n'
    + '                 +++++++++++++\n'
    + '            +++++++++++++++++++++\n'
    + '         +++++++++++++++++++++++++\n'
    + '       ++++++++++++++++++++++++++++++\n'
    + '     +++++++++++++++++++++++++++++++++++\n'
    + '    +++++++++++++++++++++++++++++++++++++\n'
    + '   +++++++++++++++++++++++++++++++++++++++\n'
    + '   ++++++++++++++++++++++++++++++++++++++++\n'
    + '   +++++++++++++++++++++++++++           +\n'
    + '   ++++++++++++++++++++++++     +++++++++\n'
    + '+   +++++++++++++++++++++   ++++++++++++++++\n'
    + '++   +++++++++++++++++++  ++++++++++++++++++++++\n'
    + '++++   +++++++++++++++  +++++++++++++++++++++++++\n'
    + '++++++  +++++++++++++++++++++++++++++++++++++++++++\n'
    + '++++++++   ++++++++++++++++++++++++++++++++++++++++\n'
    + '++++++++++    +++++++++++++++++++++++++++++++++++++++\n'
    + '++++++++++++     ++++++++ +++++++++++++++++++++++++++\n'
    + '++++++++++++++++++++++++++  +++++++++++++++++++++++++\n'
    + '++++++++++++++++++++++++++++  ++++++++++++++++++++++++\n'
    + '++++++++++++++++++++++++++++  ++++++++++++++++++++++++\n'
    + '+++++++++++++++++++++++++++   +++++++++++++++++++++++\n'
    + '++++++++++++++++++++++++++   ++++++++++++++++++++++++\n'
    + '++++++++++++++++++++++++    +++++++++++++++++++++++\n'
    + '++++++++++++++++++++++    +++++++++++++++++++++++++\n'
    + '++++++++++++++++++++    +++++++++++++++++++++++++\n'
    + '  ++++++++++++++++    +++++++++++++++++++++++++\n'
    + '     +++++++++++    +++++++++++++++++++++++++\n'
    + '        ++++++    +++++++++++++++++++++++++\n'
    + '\n'
    + '           © 3sixteen • 2003–' + y + '\n'
    + (v ? '              v' + v + (c ? ' (' + c + ')' : '') + '\n' : '');
})();

function start() {
  console.log(consoleBanner);
  window.addEventListener('touchstart', function () {
    app.set('isTouch', true);
  }, { once: true, passive: true });

  // Phase 11/12: every IIFE module/template/component is gone; the init
  // loop they used to populate is empty. Phase 13 dropped the loop and
  // the jQuery `page:ready` trigger that bridged it to ESM listeners —
  // every ESM consumer now listens on the native `ep:ready` event below.
  document.dispatchEvent(new CustomEvent('ep:ready'));
}

function breakpoints() {
  var _breakpoints = {
    portrait: "only screen and (orientation : portrait)",
    landscape: "only screen and (orientation : landscape)",
    small: "only screen and (max-width: 768px)",
    smallMedium: "only screen and (max-width: 1023px)",
    mediumOnly: "only screen and (min-width: 768px and max-width: 1023px)",
    mediumUp: "only screen and (min-width: 768px)",
    largeOnly: "only screen and (min-width: 1024px and max-width: 1439px)",
    largeUp: "only screen and (min-width: 1024px)",
    xLargeOnly: "only screen and (min-width: 1440px and max-width: 1679px)",
    xLargeUp: "only screen and (min-width: 1440px)",
    xxLarge: "only screen and (min-width: 1680px)",
    heightSmall: "only screen and (max-height: 768px)",
    heightMedium: "only screen and (min-height: 769px and max-height: 899px)",
    heightLarge: "only screen and (min-height: 900px and max-height: 1199px)",
    heightXlarge: "only screen and (min-height: 1200px)"
  };

  var breakpointsArr = {};
  for (var key in _breakpoints) {
    breakpointsArr[key] = window.matchMedia(_breakpoints[key]);
  }

  return breakpointsArr;
}

function animations() {
  var header = {
    in: {
      keyframes: [{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }],
      duration: 250
    },
    out: {
      keyframes: [{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }],
      duration: 250
    }
  },
  modal = {
    in: {
      keyframes: [{ opacity: 0 }, { opacity: 1 }],
      duration: 125
    },
    out: {
      keyframes: [{ opacity: 1 }, { opacity: 0 }],
      duration: 125
    }
  },
  lineItem = {
    in: {
      slide: 'down',
      duration: 125
    },
    out: {
      slide: 'up',
      duration: 125
    }
  },
  productError = {
    in: {
      slide: 'down',
      duration: 125
    },
    out: {
      slide: 'up',
      duration: 125
    }
  },
  stickyAtc = {
    in: {
      keyframes: [{ opacity: 0 }, { opacity: 1 }],
      duration: 125
    },
    out: {
      keyframes: [{ opacity: 1 }, { opacity: 0 }],
      duration: 125
    }
  };

  return {
    header: header,
    modal: modal,
    lineItem: lineItem,
    productError: productError,
    stickyAtc: stickyAtc
  };
}

log('[AppConfig] registered');

export { start, animations, breakpoints };
